import { useState, useEffect } from 'react';
import { readCart, subscribe } from '../lib/cart';

export default function useCart() {
  const [lines, setLines] = useState(readCart);
  useEffect(() => subscribe(setLines), []);
  return lines;
}